// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3076) return "static/chunks/3076-build-1747015995189-8fd392011333014c.js";
	if (chunkId === 9558) return "static/chunks/9558-build-1747015995189-f38db3a5e8d202db.js";
	if (chunkId === 2502) return "static/chunks/2502-build-1747015995189-8991e9d49fc233be.js";
	if (chunkId === 9575) return "static/chunks/9575-build-1747015995189-adf827b00e7d4a71.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-build-1747015995189." + {"282":"4141c319ced77fcb","1598":"61d9be6168463802","2441":"b8e62d33584c8c83","3870":"74d22f7b76a85a40","4256":"5ce6b71129250089","5312":"a106d1282e6eb2bb","5899":"5ea2c109e108a38f","9272":"f4164dd35d6e2de3"}[chunkId] + ".js";
};